import {
  NativeEventEmitter,
  NativeEventSubscription,
  NativeModules,
  Platform,
} from 'react-native';
import { EventEmitter } from 'events';

const { WebRTCModule } = NativeModules;

export const webRTCModuleEmitter = new NativeEventEmitter(WebRTCModule);

export default class AudioSampleHandler extends EventEmitter {
  private webRTCModuleEmitter: NativeEventEmitter;
  private _audioSamplesListener?: NativeEventSubscription;
  private _isListening = false;
  private _currentSamples: Float32Array;

  constructor() {
    super();
    this.webRTCModuleEmitter = webRTCModuleEmitter;
    this._audioSampleHandler = this._audioSampleHandler.bind(this);
    this._currentSamples = new Float32Array(1024);
    this.initialiseSampler();
  }

  public static async init() {
    return new AudioSampleHandler();
  }

  private _audioSampleHandler(audioData: any) {
    this._currentSamples.fill(0);
    if (Platform.OS === 'android') {
      this._currentSamples.set(audioData);
    } else {
      this._currentSamples.set(audioData.samples);
    }
  }

  private initialiseSampler() {
    this._audioSamplesListener = this.webRTCModuleEmitter.addListener(
      'audioSamples',
      this._audioSampleHandler
    );
    this._isListening = true;
  }

  public getFloatTimeDomainData(samples: Float32Array) {
    if (!this._isListening) {
      this.initialiseSampler();
    }
    samples.set(this._currentSamples);
  }

  public stopListening() {
    if (this._audioSamplesListener) {
      this._audioSamplesListener.remove();
      this._audioSamplesListener = undefined;
      this._isListening = false;
      this._currentSamples.fill(0);
    }
  }

  public destructor() {
    this.stopListening();
  }
}
